"use client";

import { useActionsTrack } from "@/_old/features/analytics";
import { FiltersProvider } from "@/_old/features/filters/context/filters";
import { DashboardBookingsTimeseriesChart } from "@/dashboard/components/dashboard-bookings-timeseries-chart";
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { DashboardFilters } from "./components/dashboard-filters";
import { DashboardFiltersBridge } from "./components/dashboard-filters-bridge";
import { DashboardHeaderActions } from "./components/dashboard-header-actions";
import { DashboardMyProductsView } from "./components/dashboard-my-products-view";
import { DashboardRankings } from "./components/dashboard-rankings";
import { DashboardSpaceUsageCards } from "./components/dashboard-space-usage-cards";
import { DashboardBannerIA } from "./components/dashboard-banner-ia";
import { DashboardBannerIASkeleton } from "./components/dashboard-banner-ia/components/dashboard-banner-ia.skeleton";
import {
  DashboardInsights,
  ExceededCardState,
} from "./components/dashboard-insights";

export const NewDashboard: FunctionComponent = () => {
  const { onActionView } = useActionsTrack();
  const [exceededCardState, setExceededCardState] = useState<ExceededCardState>(
    {
      visible: false,
      loading: true,
    },
  );

  const handleExceededCardStateChange = useCallback(
    (state: ExceededCardState) => {
      setExceededCardState(state);
    },
    [],
  );

  useEffect(() => {
    onActionView("PAGE_DASHBOARD_VIEW");
  }, [onActionView]);

  return (
    <FiltersProvider>
      <DashboardFiltersBridge />
      {/* Figma 6036:2726 / 6061:4061: seções empilhadas com 32px entre elas;
          padding 16px no mobile e 24px/32px no desktop. Banner da Bruna e
          gráfico de reservas não estão no Figma e seguem como antes. */}
      <div className="flex flex-col gap-8 p-4 min-w-0 md:px-6 md:py-8">
        <DashboardHeaderActions />
        {exceededCardState.loading && <DashboardBannerIASkeleton />}
        {!exceededCardState.loading && !exceededCardState.visible && (
          <DashboardBannerIA direction="column" carousel={false} />
        )}
        <DashboardInsights
          onExceededCardStateChange={handleExceededCardStateChange}
        />
        <DashboardFilters />
        <DashboardSpaceUsageCards />
        <DashboardBookingsTimeseriesChart />
        <DashboardRankings />
        <DashboardMyProductsView />
      </div>
    </FiltersProvider>
  );
};
